<template>
  <div class="tabbar">
    <div class="tabbar-item" :class="active == item.title ? 'active' : ''" v-for="(item,index) in menus" :key="index" @click="$router.push(item.url)">
      <img :src="item.icon_active" v-if="active == item.title" />
      <img :src="item.icon" v-else />
      <p>{{item.title}}</p>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    this.active = this.$route.meta.active
  },
  data() {
    return {
      active: '',
      menus: [
        {
          title: '首页',
          icon: require("../assets/tab_home.png"),
          icon_active: require("../assets/tab_home_active.png"),
          url: '/'
        },
        // {
        //   title: '分类',
        //   icon: require("../assets/tab_type.png"),
        //   icon_active: require("../assets/tab_type_active.png")
        // },
        // {
        //   title: '购物车',
        //   icon: require("../assets/tab_cart.png"),
        //   icon_active: require("../assets/tab_cart_active.png")
        // },
        {
          title: '我的',
          icon: require("../assets/tab_mine.png"),
          icon_active: require("../assets/tab_mine_active.png"),
          url: '/myorder'
        }
      ]
    }
  }
}
</script>
<style lang="less" scoped>
.tabbar {
  width: 100%;
  height: 0.54rem;
  background: #ffffff;
  box-shadow: 0px -1px 6px 0px rgba(0, 0, 0, 0.18);
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  display: flex;
  align-items: center;
  max-width: 750px;
  &-item {
    flex: 1;
    text-align: center;
    img {
      width: 10%;
    }
    p {
      font-size: 0.12rem;
      color: #666666;
    }
  }
  .active {
    p {
      color: #988256;
    }
  }
}
</style>